import { combine, withCallback } from 'react-hooks-combine'

import PaginationComponent from './component'

export const Pagination = combine(
  withCallback(
    'onRequestPageChange',
    (_state, { onPageChange, tableState }) =>
      ({ selected }) => {
        // Ensure selected is a number
        const pageIndex = Number(selected);

        // Preserve the original filtered state when changing pages
        const filtered = tableState?.filtered;

        // Ensure we have a valid filter structure if it exists
        const validFiltered = filtered && filtered.length > 0 ?
          filtered :
          (tableState?.filtered || undefined);

        // Change page while maintaining filters
        onPageChange(pageIndex, validFiltered);
      },
    ['onPageChange', 'tableState']
  )
)(PaginationComponent)
